import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const StyledContainer = styled.div`
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : 'black')};
  position: relative;
  //height: 100vh;
  
  display: grid;
  //grid-template-rows: auto;
  margin-bottom: 15px;
  max-width: 970px;
  grid-template-areas: 'header header header'
                       'content content content'
                       'footer footer footer';
                                            
  @media (min-width: ${breakpoints.desktop}) {
    background:linear-gradient(#383838,#2a2a2a);     
  }
`;

export const StyledContent = styled.div`
  grid-area: content;
  color: white;
  text-align: center;
  margin: 0;
  flex: 1;
  
  @media (min-width: ${breakpoints.desktop}) {
    margin: 0; 
  }
`;
